import TabHeaderOrders from './TabOrders';

export default TabHeaderOrders;
